import { FC } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { useStyles } from "./style";
import { DA_FEEDBACK_TABLE_COLUMNS } from "./daFeedbackHead";
import Loader from "router/components/Loader";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import DaFeedbackRow from "./DaFeedbackRow";
import useResize from "hooks/useResize";
import DaFeedbackHead from "./DaFeedbackHeader";

interface PropsType {}

const DaFeedbackPage: FC<PropsType> = () => {
  const classes = useStyles();
  const { width } = useResize();
  const { loadingData, dataList } = useTypeSelectors((state) => state.daFeedbackTable);

  return (
    <Box data-testid="testDaFeedback" className={classes.root}>
      <Loader isLoading={loadingData} />
      <DaFeedbackHead/>
      <TableContainer className={classes.tableContainer} component={Paper}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {DA_FEEDBACK_TABLE_COLUMNS.filter((item: any) => width < 900 ? item.id !== "desc" : true).map((item: { id: string; label: string }) => (
                <TableCell
                  id={item.id}
                  colSpan={1}
                  className={`${classes.tableCell} ${classes.tableHeadCell}`}
                >
                  <Typography style={{ fontWeight: 700 }}>{item.label}</Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {dataList.map((item) => (
              <DaFeedbackRow data={item}/>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default DaFeedbackPage;
